// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2R6aK","calendarButtons":"ClockData_calendarButtons__2fMQX"};